import tableRelatedUsers from './tableRelatedUsers';

export default {
  title: 'Users',
  attributeName: 'name',
  getURL: 'users',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: [],
  tableConfig: tableRelatedUsers,
};
